import api from '@app/api'

import type { ProductHierarchyDto } from './dtos'

const getUrl = (id: number): string => `/monitoring-lists/${id}/product-hierarchy/`

export const getProductHierarchy = async (id: number): Promise<ProductHierarchyDto[]> => {
  const url = getUrl(id)
  const response = await api.get<ProductHierarchyDto[]>(url)
  return response.data
}
